import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M9.65 3.755a6.338 6.338 0 0 1 .7 0 .7.7 0 1 1-.077 1.398 4.946 4.946 0 0 0-.546 0 .7.7 0 1 1-.077-1.398Zm3.53 1.637a.7.7 0 0 1 .988-.055c.174.155.34.32.495.495a.7.7 0 1 1-1.043.933 4.896 4.896 0 0 0-.385-.385.7.7 0 0 1-.056-.988Zm2.327 3.597a.7.7 0 0 1 .738.66 6.26 6.26 0 0 1 0 .701.7.7 0 1 1-1.398-.077 4.937 4.937 0 0 0 0-.546.7.7 0 0 1 .66-.738Zm-11.014 0a.7.7 0 0 1 .66.738 4.946 4.946 0 0 0 0 .546.7.7 0 0 1-1.398.077 6.349 6.349 0 0 1 0-.7.7.7 0 0 1 .738-.66Zm.899 4.19a.7.7 0 0 1 .988.056c.121.135.25.264.385.385a.7.7 0 0 1-.933 1.044 6.276 6.276 0 0 1-.496-.496.7.7 0 0 1 .056-.989Zm3.597 2.328a.7.7 0 0 1 .738-.66 5.036 5.036 0 0 0 .546 0 .7.7 0 1 1 .077 1.398 6.358 6.358 0 0 1-.7 0 .7.7 0 0 1-.66-.738ZM3 3.7a.7.7 0 0 1 .7-.7h4.2a.7.7 0 0 1 .7.7v4.2a.7.7 0 0 1-.7.7H3.7a.7.7 0 0 1-.7-.7V3.7Zm1.4.7v2.8h2.8V4.4H4.4ZM11.4 12.1a.7.7 0 0 1 .7-.7h4.2a.7.7 0 0 1 .7.7v4.2a.7.7 0 0 1-.7.7h-4.2a.7.7 0 0 1-.7-.7v-4.2Zm1.4.7v2.8h2.8v-2.8h-2.8Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
